
import React from "react";

const Loading = ({ message = "Loading..." }) => {
  return (
    <div className="flex justify-center items-center p-4">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#dc3545]"></div>
      <p className="ml-3 text-gray-600">{message}</p>
    </div>
  );
};

export default Loading;